<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - {{name}}</h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="handleSubmit()" class="button primary">Lagre endringer</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <TheLoader :active="$store.getters.isFormLoading"/>
    <div v-if="!$store.getters.isFormLoading" class="content-container flex-row">
      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">
          <fieldset>
            <div class="grid-x grid-padding-x">
              <!-- <TheTextInput containerClassName="cell medium-4" label="Idnr" v-model.trim="item.Idnr" :disabled="true"/> -->
              <TheTextInput containerClassName="cell medium-12" label="Navn (Etternavn, Fornavn)" name="Navn" v-model.trim="item.Navn" maxlength="50" required v-validate="'required|max:50'"/>
              <!-- <TheSwitchInput containerClassName="cell medium-4" label="Er kunstner" v-model="item.Erkunstner" labelTrue="Ja" labelFalse="Nei" trueValue="T" falseValue="F"/> -->

              <TheTextInput containerClassName="cell medium-6" label="Fødselsted" name="Fodested" v-model.trim="item.Fodested" maxlength="100" v-validate="'max:100'"/>
              <TheTextInput containerClassName="cell medium-6" label="Dødssted" name="Dodssted" v-model.trim="item.Dodssted" maxlength="100" v-validate="'max:100'"/>

              <TheIntegerInput containerClassName="cell medium-6" label="Fødselsår" name="Fodeaar" v-model.trim="item.Fodeaar" maxlength="4" v-validate="'integer|min:3|max:4|max_value:2100'"/>
              <TheIntegerInput containerClassName="cell medium-6" label="Dødsaar" name="Dodsaar" v-model.trim="item.Dodsaar" maxlength="4" v-validate="'integer|min:3|max:4|max_value:2100'"/>

              <TheTextInput containerClassName="cell medium-12" label="Periode" name="Periode" v-model.trim="item.Periode" maxlength="100" v-validate="'max:100'"/>
              <TheTextArea containerClassName="cell medium-12" label="Historie" name="Historie" v-model.trim="item.Historie" maxlength="2000" v-validate="'max:2000'" :rows="5" :autoResize="true"/>
            </div>
          </fieldset>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import KunstnerService from '@/services/KunstnerService'

export default {
  name: 'InstillingerKunstnerEdit',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    servicename: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      edit: false,
      item: {}
    }
  },
  created () {
    // Set form to loading
    this.setFormLoading(true)

    // Edit mode
    this.edit = !!this.$route.params.id

    // Load
    this.fetch()
  },
  methods: {
    fetch: function () {
      if (!this.edit) {
        this.$set(this.item, 'Erkunstner', 'F')
        this.setFormLoading(false)
      } else {
        KunstnerService.view(this.$route.params.id)
          .then((response) => {
            // Set key/values to kunstner prop
            this.item = response.data
          })
          .catch(() => {
            this.$helpers.showErrorAlert('Feil', 'Kunde ikke laste inn Kunstner')
            this.onCancel()
          })
          .then(() => {
            this.setFormLoading(false)
          })
      }
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            KunstnerService.save(this.item.Idnr, this.item)
              .then((response) => {
                // Show success alert
                this.$helpers.showSuccessAlert('Kunstner er lagret')

                this.item = response.data

                if (!this.edit) {
                  this.$router.go(-1)
                }
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
                } else {
                  this.$helpers.showErrorAlert('Noe gikk galt, prøv igjen', 'Vennligst prøv igjen', 'danger')
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    onCancel: function () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerKunstnerEdit.vue